import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { isEmpty } from 'lodash/fp';
import { Callout, ModalBody } from 'app/components/core/Modal';
import { useSelector, useDispatch } from 'app/lib/hooks';
import { Icon, IconSize } from 'app/components/core/Icon';
import {
    doLoadUserSessionWarehouses,
    selectUserSessionWarehousesList,
    selectIsUserSessionWarehousesLoading,
    selectSnowflakeRoles,
    selectIsSnowflakeRolesLoading,
    doLoadSnowflakeRoles,
    doSetUserSessionWarehouse,
    doSetSnowflakeRole,
    selectSnowflakeRolesItemInProgress,
    selectUserSessionWarehousesItemInProgress
} from 'app/store/snowflake';
import { List } from './List.jsx';
import * as styles from './RoleAndWarehouseSelector.css';

export function RoleAndWarehouseDialog({ buttonId, onClose, hasSelectedRole }) {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const warehouses = useSelector(selectUserSessionWarehousesList);
    const roles = useSelector(selectSnowflakeRoles);
    const isLoadingWarehouses = useSelector(selectIsUserSessionWarehousesLoading);
    const isLoadingRoles = useSelector(selectIsSnowflakeRolesLoading);
    const currentlyLoadingRole = useSelector(selectSnowflakeRolesItemInProgress);
    const currentlyLoadingWarehouse = useSelector(selectUserSessionWarehousesItemInProgress);
    const noWarehouses = isEmpty(warehouses);
    const noRoles = isEmpty(roles);

    useEffect(() => {
        if (noWarehouses) {
            dispatch(doLoadUserSessionWarehouses());
        }
        if (noRoles) {
            dispatch(doLoadSnowflakeRoles());
        }
    }, [noWarehouses, noRoles, dispatch]);

    const handleRoleChange = (role) => {
        dispatch(doSetSnowflakeRole({ role }));
    };
    const handleWarehouseChange = (warehouse) => {
        dispatch(doSetUserSessionWarehouse({ warehouse }));
        onClose();
    };
    return (
        <Callout
            attachTo={buttonId}
            modalClassName={styles.modal}
            placement="bottom"
            onClose={onClose}
            width={600}>
            <div className={styles.header}>
                <div>
                    <span>{t('glossary:role_other')}</span>
                    <Icon variant="chevron-right-big" size={IconSize.EXTRA_SMALL} inline />
                </div>

                <div>{t('glossary:warehouse_other')}</div>
            </div>
            <ModalBody className={styles.modalBody}>
                <List
                    items={roles}
                    isLoading={isLoadingRoles}
                    icon="role"
                    searchPlaceholder={t(
                        'components:SnowflakeConnectionStatus.modal.searchRolePlaceholder'
                    )}
                    onClick={handleRoleChange}
                    currentlyLoadingItem={currentlyLoadingRole}
                />
                <List
                    items={warehouses}
                    isLoading={isLoadingWarehouses}
                    icon="warehouse"
                    searchPlaceholder={t(
                        'components:SnowflakeConnectionStatus.modal.searchWarehousePlaceholder'
                    )}
                    onClick={handleWarehouseChange}
                    currentlyLoadingItem={currentlyLoadingWarehouse}
                    emptyStateMessage={
                        !hasSelectedRole
                            ? t('components:SnowflakeConnectionStatus.modal.noRoleSelected')
                            : null
                    }
                />
            </ModalBody>
        </Callout>
    );
}
